import { printHTML, downloadWord } from '../utils/printHelper';
import { useState, useEffect } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { Printer, FileDoc } from '@phosphor-icons/react';
import { toast } from 'sonner';
import axios from 'axios';
import ClientAutocomplete from '../components/ClientAutocomplete';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ProdajnePogodnostiPage() {
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({
    client_id: '',
    naziv_drustva: '',
    adresa_drustva: '',
    grad: 'Podgorica',
    direktor: '',
    objekat_naziv: '',
    popust_od: '5',
    popust_do: '50',
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/api/clients`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setClients(r.data.sort((a, b) => (a.skraceni_naziv || '').localeCompare(b.skraceni_naziv || ''))));
  }, []);

  const handleClientSelect = (clientId) => {
    const c = clients.find(cl => cl.id === clientId);
    if (c) setForm(prev => ({
      ...prev,
      client_id: clientId,
      naziv_drustva: c.naziv_firme || c.skraceni_naziv || '',
      adresa_drustva: [c.adresa, c.grad].filter(Boolean).join(', '),
      grad: c.grad || 'Podgorica',
      direktor: c.direktor || '',
      objekat_naziv: c.skraceni_naziv || c.naziv_firme || '',
    }));
  };

  const buildHtml = () => `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Odluka - Prodajne pogodnosti</title>
<style>
@page{size:A4;margin:20mm 25mm}
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'Times New Roman',serif;font-size:12pt;color:#000;line-height:1.6;background:#fff}
.doc{max-width:170mm;margin:0 auto}
.header{font-size:11pt;line-height:1.5;margin-bottom:15px}
.title{text-align:center;font-weight:bold;font-size:14pt;letter-spacing:3px;margin:15px 0 5px}
.subtitle{text-align:center;font-weight:bold;font-size:11.5pt;margin-bottom:15px}
.cl{font-weight:bold;font-size:11pt;margin:12px 0 5px}
.cl-title{font-weight:bold;font-size:11pt;text-transform:uppercase;margin:4px 0}
p{font-size:11pt;line-height:1.5;margin:6px 0;text-align:justify}
.sign-area{display:flex;justify-content:space-between;margin-top:30px;font-size:11pt}
.sign-left{text-align:left;font-size:10pt;line-height:1.5}
.sign-right{text-align:right;font-weight:bold}
@media print{body{margin:0}}
</style></head><body>
<div class="doc">
<div class="header">Na osnovu čl. 34. stav 1 i 2 i čl. 36. Zakona o zaštiti potrošača (&bdquo;Službeni list CG&ldquo; br. 012/2026 od 6. 01. 2026 godine) i odredbi Statuta društva sa ograničenom odgovornošću &bdquo;<strong>${form.naziv_drustva}</strong>&ldquo; DOO ${form.adresa_drustva}, maloprodajni objekat <strong>${form.objekat_naziv}</strong> i direktor &nbsp;d&nbsp;o&nbsp;n&nbsp;o&nbsp;s&nbsp;i</div>

<div class="title">O &nbsp;D &nbsp;L &nbsp;U &nbsp;K &nbsp;U</div>
<div class="subtitle">O POSEBNIM USLOVIMA PRODAJE – PRODAJNIM POGODNOSTIMA</div>

<div class="cl">čl. 1.</div>
<div class="cl-title">NAČIN PLAĆANJA U MALOPRODAJNIM OBJEKTIMA</div>
<p>U maloprodajnim objektima kupljeni proizvodi mogu se platiti:</p>
<p style="margin-left:15px">Gotovinski<br>Karticama poslovnih banaka i<br>Virmanskom uplatom</p>

<div class="cl">čl. 2.</div>
<div class="cl-title">POSEBNI USLOVI PRODAJE KOJI SE ODOBRAVAJU KAO PRODAJNE POGODNOSTI</div>
<p>Kao posebni uslov prodaje, u vidu prodajne pogodnosti odobravaju se određenim grupama potrošača (imaocima potrošačkih kartica, penzionerima i dr.) popusti od ${form.popust_od}-${form.popust_do} posto.</p>
<p>Popusti se obilježavaju postotkom pored artikla i evidentiraju se kao uslov prodaje preko ENU (Elektronskog naplatnog uređaja). Pojedinačne Odluke sa spiskom artikala za koje se odobravaju popusti, sastavni su dio ove Odluke i nalaze se u objektu kako bi se stavili na uvid nadležnim organima.</p>

<div class="cl">Čl. 3.</div>
<p>Ovu Odluku istaknuti na vidnom mjestu u maloprodajnom objektu shodno odredbama Čl. 34. stav 2 Zakona o zaštiti potrošača.</p>

<div class="sign-area">
<div class="sign-left">Dostaviti,<br>Maloprodajnom objektu<br>arhivi</div>
<div class="sign-right">DIREKTOR</div>
</div>
</div>
<script>window.onload=function(){window.print();window.onafterprint=function(){window.close()}}</script></body></html>`;

  const handlePrint = () => printHTML(buildHtml());
  const handleWord = () => downloadWord(buildHtml(), `Pogodnosti_${(form.naziv_drustva||'drustvo').replace(/\s+/g,'_')}.doc`);

  return (
    <div className="space-y-4">
      <Card className="p-4 bg-white border-slate-200">
        <h3 className="text-sm font-bold text-slate-700 mb-3">Odluka - Prodajne pogodnosti</h3>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Klijent</Label>
            <ClientAutocomplete clients={clients} value={form.client_id} onChange={(id) => (handleClientSelect)(id || 'none')} testid="pogodnosti-client-select" placeholder="Pretraga po nazivu ili PIB-u..." />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Naziv objekta</Label>
            <Input value={form.objekat_naziv} onChange={e => setForm({...form, objekat_naziv: e.target.value})} className="bg-white border-slate-300 text-sm" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Popust od (%)</Label>
            <Input value={form.popust_od} onChange={e => setForm({...form, popust_od: e.target.value})} className="bg-white border-slate-300 text-sm" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Popust do (%)</Label>
            <Input value={form.popust_do} onChange={e => setForm({...form, popust_do: e.target.value})} className="bg-white border-slate-300 text-sm" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Direktor</Label>
            <Input value={form.direktor} onChange={e => setForm({...form, direktor: e.target.value})} className="bg-white border-slate-300 text-sm" readOnly />
          </div>
        </div>
        <div className="flex gap-2 mt-3">
          <Button onClick={handlePrint} className="bg-slate-800 hover:bg-slate-700 text-sm" disabled={!form.client_id} data-testid="print-pogodnosti-btn">
            <Printer size={16} className="mr-2" /> Štampaj odluku
          </Button>
          <Button onClick={handleWord} className="bg-indigo-600 hover:bg-indigo-700 text-sm text-white" disabled={!form.client_id} data-testid="word-pogodnosti-btn">
            <FileDoc size={16} className="mr-2" /> Word
          </Button>
        </div>
      </Card>
    </div>
  );
}
